import React, { useEffect } from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
  Redirect,
  useLocation,
} from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { GuardRoute } from '../_shared/GuardRoute';

import { MyAccount } from './my-account/MyAccount';
import { PersonalInformation } from './personal-information/PersonalInformation';
import { CommunicationPreferences } from './communication-preferences/CommunicationPreferences';
import { ChangePassword } from './change-password/ChangePassword';
import { MultiFactorAuthentication } from './multi-factor-authentication/MultiFactorAuthentication';
import { EgsRedirect } from './providers/egs/EgsRedirect';
import { SteamRedirect } from './providers/steam/SteamRedirect';
import { Game } from './my-games/Game';
import { Preregistration } from '../preregistration/Preregistration';
import { post } from '../utils/Request';
import { useConfig } from '../ConfigContext';
import { useAuth } from '../authentication/AuthenticationContext';

export function Account(): JSX.Element {
  const config = useConfig();
  const match = useRouteMatch();
  const auth = useAuth();

  const location = useLocation();

  // TODO: Remove after promotion overhaul (CT-889)
  useEffect(() => {
    const lastSync = localStorage.getItem(`lastSync-${auth.user?.email}`);
    const yesterday = Date.now() - 3600000;
    if (!lastSync || Number(lastSync) < yesterday) {
      post(`${config.clientConfig.host}/players/me/promotions/sync`);
      localStorage.setItem(`lastSync-${auth.user?.email}`, `${Date.now()}`);
    }
  }, []);

  return (
    <>
      <AnimatePresence exitBeforeEnter>
        <Switch location={location} key={location.pathname}>
          <Route path={`${match.path}/my-account`} exact component={MyAccount} />

          <Route path={`${match.path}/my-account/games/:gameId`} exact component={Game} />
          <GuardRoute path={`${match.path}/my-account/games/:gameId/preregistration`} authRoute>
            <Preregistration />
          </GuardRoute>

          <Route path={`${match.path}/personal-information`} exact component={PersonalInformation} />
          <Route
            path={`${match.path}/communication-preferences`}
            exact
            component={CommunicationPreferences}
          />
          <Route path={`${match.path}/change-password`} exact component={ChangePassword} />
          <Route path={`${match.path}/mfa`} exact component={MultiFactorAuthentication} />
          <Route path={`${match.path}/egs/redirect`} exact component={EgsRedirect} />
          <Route path={`${match.path}/steam/redirect`} exact component={SteamRedirect} />

          <Redirect to={`${match.path}/my-account`} />
        </Switch>
      </AnimatePresence>
    </>
  );
}
